module.exports = __webpack_public_path__ + "static/media/BOG-6.78a4c06b.pdf";